export const isClientClassEnabled = () =>
  process.env.REACT_APP_CLIENT_CLASS_ENABLED === "true";

export const CLIENT_CLASS_FILTER_VALUES = [
  { value: "Full", label: "Full" },
  { value: "GI Only", label: "GI Only" },
];
